module.exports = __webpack_public_path__ + "static/uk_aid_logo-fd78de7908f37e5c71588a4a2a37c69f.webp";